import { render, staticRenderFns } from "./DdpSummaryCard.vue?vue&type=template&id=394daf32"
import script from "./DdpSummaryCard.vue?vue&type=script&lang=js"
export * from "./DdpSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports